import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=4766aeda&scoped=true&"
import script from "./DesktopNav.vue?vue&type=script&setup=true&lang=js&"
export * from "./DesktopNav.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DesktopNav.vue?vue&type=style&index=0&id=4766aeda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4766aeda",
  null
  
)

export default component.exports